import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CmsContentService, UiTextKind } from '../services/cms-content.service';

/**
 * Resolves a "days ago" style CMS text (today/yesterday/other, e.g. `si_pts_chrome_history_gambling_data_timestamp`)
 * by picking the `_today`/`_yesterday`/`_other` suffix off `days` and substituting `{date}` in the `_other` text,
 * e.g. `{{ analysis_days | relativeDateCmsText:'si_pts_chrome_history_gambling_data_timestamp':result?.analysis?.created_at | async }}`.
 */
@Pipe({
  name: 'relativeDateCmsText',
  standalone: true,
})
export class RelativeDateCmsTextPipe implements PipeTransform {

  constructor(private cms: CmsContentService, @Inject(LOCALE_ID) private locale: string) { }

  transform(days: number, keyPrefix: string, date: string | number | Date | null | undefined, kind: UiTextKind = 'ChromeLabel'): Observable<string> {
    const suffix = days === 0 ? 'today' : days === 1 ? 'yesterday' : 'other';
    const key = `${keyPrefix}_${suffix}`;

    return this.cms.getByKey(key, this.locale, kind).pipe(
      map(dto => {
        const text = dto?.text?.length ? dto.text : key;
        return suffix === 'other' && date
          ? text.replace('{date}', formatDate(date, 'mediumDate', this.locale))
          : text;
      })
    );
  }
}
